module.exports = __webpack_public_path__ + "static/media/carousel10.135c0257.jpeg";